module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w1"
  }, [_c('div', {
    staticClass: "wrap-admin"
  }, [_c('div', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "all-pages-list",
    attrs: {
      "div": ""
    }
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("All landing pages")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-homepage')
      }
    }
  }, [_vm._v("Homepage")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('homepage')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('homepage')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-about')
      }
    }
  }, [_vm._v("About page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('about-us')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('about-us')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-login')
      }
    }
  }, [_vm._v("Login page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('login-page')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('login-page')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-download-brochure')
      }
    }
  }, [_vm._v("Download brochure page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('download-brochure-page')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('download-brochure-page')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-contact')
      }
    }
  }, [_vm._v("Contact page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('contact-page')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('contact-page')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-terms-and-conditions')
      }
    }
  }, [_vm._v("Terms and conditions")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('terms-and-conditions')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('terms-and-conditions')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-privacy-policy')
      }
    }
  }, [_vm._v("Privacy policy")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('privacy-policy')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('privacy-policy')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-accessibility-section')
      }
    }
  }, [_vm._v("Accessibility section")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('accessibility-section')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('accessibility-section')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-cookies')
      }
    }
  }, [_vm._v("Cookies")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('cookies')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('cookies')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-give-consent')
      }
    }
  }, [_vm._v("Give consent page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('give-consent')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('give-consent')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-confirm-subscription')
      }
    }
  }, [_vm._v("Confirm subscription page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('confirm-subscription')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('confirm-subscription')
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _c('tr', [_c('td', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageEdit('edit-clear-kit')
      }
    }
  }, [_vm._v("ClearKit page")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importPage('clear-kit')
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportPage('clear-kit')
      }
    }
  }, [_vm._v("Export")])])])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "href": "#",
      "id": "exportLanding"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "file",
      "id": "importLanding"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Page name")])])])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                  Actions\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a91c218","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/EditLandingPages.vue
// module id = 967
// module chunks = 1